module.exports = __webpack_public_path__ + "static/media/AllThatShip.3b5c01b8.png";